import { render, staticRenderFns } from "./QueueManagementDialog.vue?vue&type=template&id=9dfaf228"
import script from "./QueueManagementDialog.vue?vue&type=script&lang=js"
export * from "./QueueManagementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports